import React from "react";

import { ColDef, RowDoubleClickedEvent, SelectionChangedEvent, } from "ag-grid-community";

import BaseGrid from "../../../components/BaseGrid";

import { Option } from "../data/Option";

import { useCategoryContext } from "../context/CategoryContext";
import { useOptionGridStore } from "../store/OptionGridStore";
import { useOptionDrawerStore } from "../store/OptionDrawerStore";

export default function OptionGrid() {
    const { options, isOptionsFetching, refetchOptions } = useCategoryContext();
    const { openEdit } = useOptionDrawerStore();
    const { setSelectedOptions } = useOptionGridStore();

    React.useEffect(() => {
        refetchOptions();
    }, [refetchOptions]);

    const colDefs = React.useMemo<ColDef[]>(() => {
        return [
            {
                field: "id",
                headerName: "ID",
                filter: true,
                minWidth: 95,
                maxWidth: 105,
            },
            {
                field: "name",
                headerName: "Name",
                minWidth: 200,
            },
            {
                field: "order",
                headerName: "Order",
                minWidth: 120,
                maxWidth: 140,
            },
        ];
    }, []);

    const handleRowDoubleClick = React.useCallback((e: RowDoubleClickedEvent) => {
        const option = e.data as Option;
        openEdit(option);
    }, [openEdit]);

    const onSelectionChanged = React.useCallback((e: SelectionChangedEvent) => {
        setSelectedOptions(e.api.getSelectedRows() as Option[]);
    }, [setSelectedOptions]);

    const onReset = React.useCallback(() => {
        setSelectedOptions([]);
    }, [setSelectedOptions]);

    return (
        <BaseGrid<Option>
            isSingle={true}
            isLoading={isOptionsFetching}
            data={options}
            colDefs={colDefs}
            onRowDoubleClick={handleRowDoubleClick}
            onSelectionChanged={onSelectionChanged}
            onReset={onReset}
        />
    );
}
